import { isObject } from "commons/ZimssaHelper";

export interface IProfileRegisterState {
  serviceImages: string[];
  email: string;
  carrierYear: number;
  sizeTo: string;
  unitPrice: string;
  fixedPrice: string;
}

export interface IProfileRegisterAction {
  type: keyof IProfileRegisterState | 'SET_STATE';
  value?: IProfileRegisterState[keyof IProfileRegisterState] | IProfileRegisterState;
}

export const defaultState: IProfileRegisterState = {
  serviceImages: [],
  email: '',
  carrierYear: 0,
  sizeTo: '',
  unitPrice: '',
  fixedPrice: '',
};

export interface IProfileRegisterReducer {
  (
    state: IProfileRegisterState,
    action: IProfileRegisterAction
  ): IProfileRegisterState;
}

export default function profileRegisterReducer(state: IProfileRegisterState, action: IProfileRegisterAction): IProfileRegisterState {
  const { type, value } = action;

  switch (type) {
    case 'SET_STATE':
      if (isObject(value)) {
        state = value as IProfileRegisterState || state;
      } else {
        state = defaultState;
      }
      break;
    default:
      state = { ...state, [type]: value };
      break;
  }

  return state;
}
